// @flow

import React, { Component } from 'react';
import logo from './logo.svg';
import Search from './components/search';
import Status from './components/status';
import Typed from 'react-typed';
import { Transition } from 'semantic-ui-react';
import './App.css';

type Props = {

}

type State = {
  isSearching: boolean,
  results: any[],
  searchProgress: number,
}

class App extends Component<Props, State> {
  constructor(props: Props){
    super(props);

    this.state = {
      isSearching: false,
      results: [],
      searchProgress: 0,
    };
  }

  render() {
    const statusList = [
      <Status
        show={this.state.isSearching && this.state.searchProgress === 0}
        title="Searching"
        subtitle="Finding the best places in Christchurch, sit back and relax"
        icon="search"
      />,
      <Status
        show={!this.state.isSearching && this.state.searchProgress === 1}
        title="Oh no!"
        subtitle={
          <div>
          <h4>Count'd find anything to do in Christchurch</h4>
          <a href="https://www.skyscanner.co.nz/transport/flights-from/chc?adults=1" >How about this</a>
          </div>
        }
        icon="x"
      />
    ];
    return (
      <div className="app">
        <h1>What would you like to do in Christchurch?</h1>
        <h4 className="app-subtitle">
          <span>I want to </span>
          <Typed
            strings={[
              'go biking',
              'explore the city',
              'find a cozy restaurant',
              'try something new and exciting',
              'see what festivals are on',
              'relax with a brew'
            ]}
            typeSpeed={40}
            backSpeed={20}
            loop
          />
        </h4>

        <Search
          isSearching={this.state.isSearching}
          onSearch={
            () => {
              this.setState({
                isSearching: !this.state.isSearching,
              });
              setInterval(() => {
                this.setState({
                  isSearching: false,
                  results: [],
                  searchProgress: 1,
                });
              }, 5000);
            }
          }
        />
        {statusList[this.state.searchProgress]}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js